import React from "react";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-6 text-sm text-slate-600">
        Copyright 2026 Bookerail. All rights reserved.
      </div>
    </footer>
  );
}
